import {commonSlice} from './reducers'

export const {
    setSnackbar, 
    setSpinner,
    setProfileActiveTab
} = commonSlice.actions;
export default commonSlice.actions